import NavBar from "@/components/site/NavBar";
import Hero from "@/components/site/Hero";
import VturbPlayer from "@/components/site/VturbPlayer";
import AttorneyBar from "@/components/site/AttorneyBar";
import FearSection from "@/components/site/FearSection";
import FounderStory from "@/components/site/FounderStory";
import GoogleReviews from "@/components/site/GoogleReviews";
import Testimonials from "@/components/site/Testimonials";
import FinalCTA from "@/components/site/FinalCTA";
import Footer from "@/components/site/Footer";

/**
 * Child Custody landing — VSL variant #2.
 *
 * Same full hero as the standard Child Custody page (headline, subhead,
 * prior-results disclaimer, image, stat bar, form) — nothing stripped —
 * with the Vturb SmartPlayer section injected immediately after the hero
 * so the video appears as the first thing the visitor sees on scroll.
 *
 * Leads tagged `source="Child Custody VSL v2"`.
 */
export default function LandingVSLSplit() {
  return (
    <main data-testid="landing-vsl-split-page" className="relative bg-paper text-ink">
      <NavBar />
      <Hero source="Child Custody VSL v2" compact />
      <VturbPlayer videoId="6a59cee0318b789100b72048" />
      <AttorneyBar />
      <FearSection />
      <FounderStory />
      <GoogleReviews />
      <Testimonials />
      <FinalCTA source="Child Custody VSL v2" />
      <Footer />
    </main>
  );
}
